import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { Avatar } from 'shared-components/image/avatar';
import { FormattedMessage } from 'react-intl';


export class JoinBlockerModal extends Component {
  componentDidMount () {
    analyticsIntegrations.boardJoinViewed(this.props.boardId);
  }

  render () {
    const {
      boardOwnerName,
      boardOwnerAvatarId = '',
      onJoinClick,
      onDismissClick,
      boardName
    } = this.props;

    const boardOwnerPosessive = boardOwnerName ? `${boardOwnerName}'s ` : '';

    return (
      <BootstrapModal
        {...this.props}
        addCloseIcon={false}
        modalClass="permission-modal"
        header={
          <div>
            { boardOwnerAvatarId &&
              (<Avatar
                dataSrc
                id={boardOwnerAvatarId}
              />)
            }
            <p className="margin-lg-top margin-md-bottom heavier">{`Join ${boardOwnerPosessive}Board`}</p>
            <h4>{boardName}</h4>
          </div>
        }
        body={
          <div className="text-center">
            <div className="d-flex align-items-center">
                <div className="text-gray-dark">
                  <FormattedMessage
                    id='web_2.project_join_blocker_modal.intro_message'
                    defaultMessage='Joining this board gives you access to comment, vote, and collaborate on spaces.'
                  />
                </div>
                <div>
                  <button className="btn btn-primary btn-login margin-lg-bottom" onClick={onJoinClick}>
                    <FormattedMessage
                      id='web_2.project_join_blocker_modal.button_label'
                      defaultMessage='Join Board'
                    />
                  </button>
                </div>
                <div>
                  <button className="btn btn-no-outline" data-dismiss="modal" onClick={onDismissClick}>
                    <FormattedMessage
                      id='web_2.project_join_blocker_modal.button_label_not_now'
                      defaultMessage='Not now'
                    />
                  </button>
                </div>
              </div>
          </div>
        }
      />
    );
  }
}


JoinBlockerModal.propTypes = {
  onJoinClick: PropTypes.func,
  boardOwnerName: PropTypes.string,
  boardOwnerAvatarId: PropTypes.string,
  boardId: PropTypes.string
};
